export default function validarCNPJ(pCnpj) {
    // Remove caracteres não alfanuméricos
    pCnpj = pCnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');

    // Verifica se o pCnpj tem o tamanho correto (14 caracteres)
    if (pCnpj.length > 14) {
        return false;
    } else if (pCnpj.length < 14) {
        pCnpj = infraLPad(pCnpj, 14, '0');
    }

    // Separa os dígitos verificadores
    const dv1 = parseInt(pCnpj.slice(-2, -1));
    const dv2 = parseInt(pCnpj.slice(-1));

    // Calcula o primeiro dígito verificador
    let soma1 = 0;
    let peso1 = 5;
    for (let i = 0; i < 12; i++) {
        const valor = pCnpj[i].charCodeAt(0) - 48;
        soma1 += valor * peso1;
        peso1 = (peso1 === 2) ? 9 : peso1 - 1;
    }
    const resto1 = soma1 % 11;
    const dv1Calculado = (resto1 < 2) ? 0 : 11 - resto1;

    // Calcula o segundo dígito verificador
    let soma2 = 0;
    let peso2 = 6;
    for (let i = 0; i < 13; i++) {
        const valor = pCnpj[i].charCodeAt(0) - 48;
        soma2 += valor * peso2;
        peso2 = (peso2 === 2) ? 9 : peso2 - 1;
    }
    const resto2 = soma2 % 11;
    const dv2Calculado = (resto2 < 2) ? 0 : 11 - resto2;

    // Compara os dígitos verificadores calculados com os fornecidos
    return (dv1 === dv1Calculado && dv2 === dv2Calculado);
}

function infraLPad(str, tam, car) {
    var dif = tam - str.length;
    var ch = String(car).charAt(0);
    for (; dif > 0; dif--) str = ch.concat(str);
    return str;
}
